import React, {useContext, useState} from 'react';
import {Button, Container, Modal, Spinner} from 'react-bootstrap';
import {FaTrashAlt} from 'react-icons/fa';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import {fetchCurrentUserAssigns, sendEmailToCustomer} from "../../../http/bookAPI";
import {Context} from "../../../index";
import {check, updateUserVirtBalanceCancelAssignmentApi} from "../../../http/userAPI";
import Loader from "../../Loader";
import {LIBRARY_ROUTE, STORE_ROUTE} from "../../../utils/consts";
import { useNavigate } from 'react-router-dom';

const CancelAssignmentModal = ({ show, assignobject, onClose, bonusToCancel }) => {
   const {book, user} = useContext(Context)
   const navigate = useNavigate();

    // Массив причин отказа
    const reasons = [
        { id: 1, text: "This book/product is low quality" },
        { id: 2, text: "I couldn't download the file, the link is broken" },
        { id: 11, text: "Amazon is not accepting reviews on this product from my account" },
        { id: 3, text: "I found a better deal in the library" },
        { id: 4, text: "I'm in a bad mood and don't feel like reviewing this book/product" },
        { id: 5, text: "Personal reasons that I don’t want to share" },
        { id: 10, text: "Accidentally clicked Take this Assignment instead of Close" },
    ];

    if (assignobject?.assTypeId === 5 || assignobject?.assTypeId === 6) {
        reasons.splice(0, 0, {
            id: 6,
            text: "I couldn’t find this book/product in Amazon search (pages 1–7)"
        });
    }

    if ([3, 4, 5, 6, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27].includes(assignobject?.assTypeId)) {
        reasons.splice(0, 0, {
            id: 9,
            text: "This book/product is not available for purchase in my region."
        });
    }

    if ([3, 4, 5, 6, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27].includes(assignobject?.assTypeId)) {
        reasons.splice(0, 0, {
            id: 8,
            text: "This book/product does not exist on Amazon."
        });
    }

    if ([3, 4, 5, 6, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27].includes(assignobject?.assTypeId)) {
        reasons.splice(0, 0, {
            id: 7,
            text: "The price shown isn’t the same as on Amazon."
        });
    }

    const [selectedReasonId, setSelectedReasonId] = useState("");
    const [loading, setLoading] = useState(false);

   const internalHandleClose = () =>{
       setSelectedReasonId ("");
       onClose();
   };

    const threeLineToast = (title, message, newBalance) => {
        toast.success(
            <div >
                <div style={{ fontSize: '14px', fontWeight: 'bold', lineHeight: '1.4' }}>{title}</div>
                <div style={{ fontSize: '12px', lineHeight: '1.2', marginTop: '4px' }}>{message}</div>
                <div style={{ fontSize: '12px', lineHeight: '1.2', marginTop: '4px' }}>{newBalance}</div>
            </div>,
            { position: "top-center", autoClose: 8000 }
        );
    };


    const cancelAssign = async () => {
        if (!assignobject.id) {
            toast.error("Please select an assignment to modify.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        if (!selectedReasonId) {
            toast.error("Please select a reason", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        setLoading(true);

        try {
            const selectedReasonIdText = reasons.find(r => r.id === Number(selectedReasonId))?.text || "";

            //Обновляем баланс пользователя в базе и отменяем задание
            const assignmentId = assignobject?.id || 0;
            const updateUserData = await updateUserVirtBalanceCancelAssignmentApi(assignmentId, selectedReasonIdText, selectedReasonId);
            threeLineToast(updateUserData.title, updateUserData.message, updateUserData.newBalance);

            // 📌 Обновляем баланс в MobX store
            const data = await check();
            user.setUser(data);

            // 🔥 Запрашиваем обновленный список после отмены
            const updatedAssignments = await  fetchCurrentUserAssigns(user.user.id);
            book.setCurrentUserAssigns(updatedAssignments);
            // Переключаем компонент на AssignUserList
            user.setActiveComponent("MainPageDashboard");
            setSelectedReasonId("");
            onClose(); // Закрываем модальное окно

        } catch (error) {
            const errorMessage = error.response?.data?.message || "An error occurred while adding the assignment.";
            toast.error(`${errorMessage}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setLoading(false);
        } finally {
            if (assignobject.book?.book_type === 'product') {
                navigate(STORE_ROUTE);
            } else {
                navigate(LIBRARY_ROUTE);
            }
            setLoading(false);
        }
    };


    return (
        <Modal show={show} onHide={internalHandleClose} top>
            <div className="modal-content">
                {/* Header */}
                <div className="modal-header small" style={{ height: 40 }}>
                    <h1 className="modal-title fs-5">Cancel Assignment</h1>
                    <button type="button" className="btn-close" aria-label="Close" onClick={internalHandleClose}></button>
                </div>

                {/* Body */}
                <div className="modal-body small" style={{ lineHeight: "1.4" }}>
                    {loading ? (

                            <Loader />

                    ) : (
                        <Container>
                            <div className="mb-3">
                                <h6 className="fw-bold text-muted">
                                    Why are you canceling this assignment?
                                </h6>
                                <p className="text-muted">
                                    Select the reason that best describes your situation. The author will see your feedback and may improve the book. Thank you for your honesty!
                                </p>
                                <select
                                    className="form-select form-select-sm"
                                    value={selectedReasonId}
                                    onChange={(e) => setSelectedReasonId(Number(e.target.value))}
                                >
                                    <option value="">Select a reason</option>
                                    {reasons.map((reason) => (
                                        <option key={reason.id} value={reason.id}>
                                            {reason.text}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {bonusToCancel > 0 && Number(selectedReasonId) !== 11 && (
                                <div className="alert alert-warning small mb-0">
                                    <strong>Note:</strong> Canceling will remove the <strong>{bonusToCancel} Virt bonus</strong> you previously received.
                                </div>
                            )}
                        </Container>
                    )}
                </div>

                {/* Footer */}
                <div
                    className="modal-footer small d-flex align-items-center justify-content-end gap-2 px-2"
                    style={{ height: 50, paddingTop: 0, paddingBottom: 0 }}
                >
                    <Button variant="secondary" onClick={internalHandleClose} disabled={loading}
                    className=" text-white btn btn-sm">
                        Close
                    </Button>
                    <Button
                        variant="secondary"
                        className="shadow-sm btn-sm d-flex justify-content-center align-items-center"

                        onClick={cancelAssign}
                        disabled={loading || !selectedReasonId}
                    >
                        {loading ? "Saving..." : (<>
                            <FaTrashAlt className="me-2"/> Cancel Assignment</>)}
                    </Button>
                </div>
            </div>
        </Modal>

);
};

export default CancelAssignmentModal;
